import { supabase } from "../lib/supabase";

export async function createTask(projectId, customerId, title) {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user) throw new Error("Not logged in");

  const { data, error } = await supabase
    .from("tasks")
    .insert([{
      user_id: user.id,
      project_id: projectId,
      customer_id: customerId,
      title,
      status: "todo",
      priority: "medium",
      progress_pct: 0,
    }])
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function getTasksForProject(projectId) {
  const { data, error } = await supabase
    .from("tasks")
    .select("*")
    .eq("project_id", projectId)
    .order("created_at", { ascending: true });

  if (error) throw error;
  return data || [];
}

export async function updateTask(taskId, patch) {
  const { data, error } = await supabase
    .from("tasks")
    .update(patch)
    .eq("id", taskId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteTask(taskId) {
  const { error } = await supabase
    .from("tasks")
    .delete()
    .eq("id", taskId);

  if (error) throw error;
}
